
import './GrayBox.scss';

export default function GrayBox({ className, ...props }) {
    return (
        <div className={`GrayBox ${className}`}>
            {props.children}
        </div>
    )
}